module.exports = __webpack_public_path__ + "img/wechat.755eac6b.jpg";